import { render, staticRenderFns } from "./GovernanceEventDetailsModal.vue?vue&type=template&id=54d50c78&"
import script from "./GovernanceEventDetailsModal.vue?vue&type=script&lang=js&"
export * from "./GovernanceEventDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports